import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IDelegateProps } from './IDelegateProps';
import { DelegateModal } from './DelegateModal';

export const DelegateExecutor = createActivityModalExecutor<IDelegateProps>({
    modal: DelegateModal,
    defaultModalSize: 'l',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        docId: (action as IActivityAction)?.docId ?? '-1',
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
